<template>
    <div>
        <v-dialog v-model="dialog_barcode_config" no-click-animation lazy transition="dialog-bottom-transition">

            <v-card flat>
                <v-card-title class="title noshadow">
                    Customize Field
                </v-card-title>
                <v-divider></v-divider>
                <!-- <v-toolbar flat>
                    <v-toolbar-side-icon @click="dialog_barcode_config = false"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
                    <v-toolbar-title>Barcode Configurations</v-toolbar-title>
                </v-toolbar> -->

                <!-- {{ scannedBarcode }} -->

               <!-- <div style="height: 100px;">
                 <v-text-field
                    label=""
                    id="id"
                    v-model="scannedBarcode"
                    placeholder=" "
                ></v-text-field>
                <v-btn color="success" @click="fn_barcodeData(scannedBarcode)">Add</v-btn>
               </div> -->

                <v-card-text class="pa-0 pt-3">

                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 form-item>
                            <v-text-field
                                label="Field Name"
                                id="id"
                                v-model="$parent.newField.fieldName"
                                :disabled="true"
                                placeholder=" "
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item>
                            <v-select
                                label="Font Size"
                                v-model="field.fontSize"
                                :items="[10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]"
                                outlined
                                dense
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item>
                            <v-select
                                label="Font Family"
                                v-model="field.fontFamily"
                                :items="['Arial', 'Verdana', 'Times New Roman', 'Courier New', 'Georgia']"
                                outlined
                                dense
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item style="display: flex;align-items: center;height: 48px;">
                            Font Bold
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item right-align style="display: flex;align-items: center;justify-content: flex-end;height: 48px;">
                            <v-checkbox v-model="field.fontBold" style="flex:none;"></v-checkbox>
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item style="display: flex;align-items: center;height: 48px;">
                            Font Italic
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item right-align style="display: flex;align-items: center;justify-content: flex-end;height: 48px;">
                            <v-checkbox v-model="field.fontItalic" style="flex:none;"></v-checkbox>
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item style="display: flex;align-items: center;height: 48px;">
                            Vertical Layout
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item right-align style="display: flex;align-items: center;justify-content: flex-end;height: 48px;">
                            <v-checkbox v-model="field.verticalLayout" style="flex:none;"></v-checkbox>
                        </v-flex>

                        <!-- <v-flex xs6 sm6 md6 form-item>
                            <v-select
                                label="Layout Direction"
                                v-model="field.layoutDirection"
                                :items="['Vertical', 'Horizontal']"
                                outlined
                                dense
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item>
                            <v-select
                                label="Font Style"
                                v-model="field.fontStyle"
                                :items="['Normal', 'Italic']"
                                outlined
                                dense
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 sm6 md6 form-item>
                            <v-select
                                label="Font Weight"
                                v-model="field.fontWeight"
                                :items="['Normal', 'Bold']"
                                outlined
                                dense
                            ></v-select>
                        </v-flex> -->
                    </v-layout>

                    
                    <!-- <v-list> -->
                        <!-- <v-list-tile avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Vertical</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-switch v-model="field.verticalDirection"></v-switch>
                            </v-list-tile-action>
                        </v-list-tile> -->

                        <!-- <v-list-tile avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Font Size</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-select
                                    v-model="field.fontSize"
                                    :items="[10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]"
                                    outlined
                                    dense
                                ></v-select>
                            </v-list-tile-action>
                        </v-list-tile> -->

                        <!-- <v-list-tile avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Font Family</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-select
                                    v-model="field.fontFamily"
                                    :items="['Arial', 'Verdana', 'Times New Roman', 'Courier New', 'Georgia']"
                                    outlined
                                    dense
                                ></v-select>
                            </v-list-tile-action>
                        </v-list-tile> -->

                        <!-- <v-list-tile avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Font Style</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-select
                                    v-model="field.fontStyle"
                                    :items="['Normal', 'Italic']"
                                    outlined
                                    dense
                                ></v-select>
                            </v-list-tile-action>
                        </v-list-tile> -->

                        <!-- <v-list-tile avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Font Style</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-select
                                    v-model="field.fontWeight"
                                    :items="['Normal', 'Bold']"
                                    outlined
                                    dense
                                ></v-select>
                            </v-list-tile-action>
                        </v-list-tile> -->
                    <!-- </v-list> -->

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="dialog_barcode_config = false">Cancel</v-btn>
                    <v-btn color="primary" flat @click="$parent.fn_saveConfig(field)">Done</v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
let scannerListener;
export default{
    props:['closeDialog'],
    data(){	
		return{
			dialog_barcode_config: false,
            field: {
                fontSize: 16,
                fontFamily: 'Arial',
                fontBold: false,
                fontItalic: false,
                verticalLayout: false
            }
        }
	},
    methods:{
        openDialogWeb: function () {
            if(!this.dialog_barcode_config){

                this.field.fontSize = this.$parent.newField.fontSize || 16;
                this.field.fontFamily = this.$parent.newField.fontFamily || 'Arial';
                this.field.fontBold = this.$parent.newField.fontWeight == 'Bold' || false;
                this.field.fontItalic = this.$parent.newField.fontStyle == 'Italic' || false;
                this.field.verticalLayout = this.$parent.newField.layoutDirection == 'Vertical' || false;

                this.dialog_barcode_config = true;
                // window.js_globals.fn_barcodeData = this.fn_barcodeData;
                // window.js_globals.fn_barcodeScanUSB = this.fn_barcodeScanUSB;
                // window.js_globals.fn_hideBarcodeScanner = this.fn_hideScanner;

                // if(localStorage.getItem('usb_scanner')){
                //     this.usbScanner = true;
                // }

                // // Remove Listener
                // if(scannerListener){
                //     document.removeEventListener("keydown", scannerListener);
                // }

                // let buffer = "";
                // let lastTime = Date.now();
                // let self = this;

                // scannerListener = function(e) {
                //     // alert('in');
                //     const now = Date.now();

                //     if (now - lastTime > 300) {
                //         buffer = "";
                //     }

                //     if (e.key.length === 1) {
                //         buffer += e.key;
                //     }

                //     if (e.key === "Enter") {
                //         self.fn_barcodeData(buffer);
                //         console.log("Scanned:", buffer);
                //         buffer = "";
                //     }

                //     lastTime = now;
                // }

                // // Attach listener
                // document.addEventListener("keydown", scannerListener);
            }


            // Attach listener
            // document.addEventListener("keydown", this.fn_usbScannerListener);
            // if(!this.usbScanner){
            //     this.fn_showScanner();
            // }
		},
		closeDialogWeb: function () {
			this.dialog_barcode_config = false;

            // if(document.getElementById('s_btn')){
            //     setTimeout(() => {
            //         document.getElementById('s_btn').style.position = 'fixed';
            //         document.getElementById('s_btn').style.width = '100%';
            //     }, 500);

            //     setTimeout(() => {
            //         document.getElementById('s_btn').style.position = 'static';
            //     }, 800);
            // }

            // // Remove Listener
            // if(scannerListener){
            //     document.removeEventListener("keydown", scannerListener);
            // }
		}
    },
    // mounted: function(){
    //     window.js_globals.fn_barcodeData = this.fn_barcodeData;
    //     this.fn_showScanner();
    // }
}
</script>


// WEBPACK FOOTER //
// src/components/barcode/dialog_barcode_config.vue